import React from 'react';
import {Container} from 'reactstrap';

const Footer: React.FC = () => (
    <footer className="footer">
        <Container>
            <span className="text-muted">Copyright &copy; Andrea Ghidini - 2023</span>
        </Container>
    </footer>
);

export default Footer;
